import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {
  Competitor,
  ControlPointTime,
  Lookups,
  RaceSettings,
  WaypointType
} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-delete-competitor-measurement-times',
  templateUrl: './delete-competitor-measurement-times.component.html',
  styleUrl: './delete-competitor-measurement-times.component.scss'
})
export class DeleteCompetitorMeasurementTimes extends AbstractComponent implements OnInit {
  @Input({ required: true }) title: string = "";
  @Input() confirmButtonTitle?: string;
  @Input({ required: true }) competitor?: Competitor;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() raceSettings: RaceSettings | undefined;

  @Output() onSave = new EventEmitter<Competitor>();


  saveEnabled: boolean = false;
  disableAll: boolean = false;

  controlTimes?: ControlPointTime[];

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
      this.controlTimes = this.competitor?.controlPointsTimes?.filter(item => item.id).map(item => ({ id: item.id, time: item.time ? new Date(item.time) :  undefined, chipTime: item.chipTime ? new Date(item.chipTime) : undefined, controlWaypoint:item.controlWaypoint, lap:item.lap, penaltyMinutes: item.penaltyMinutes, selected: false })) || [];
  }

  onConfirmClick(): void {
    if (this.competitor) this.competitor.controlPointsTimes = this.controlTimes?.filter(cpt => cpt.selected);
    this.onSave.emit(this.competitor);
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

  onItemSelect(controlPointTime: ControlPointTime) {
    if (controlPointTime.controlWaypoint?.waypointTypeId === WaypointType.START_WAYPOINT) {
      controlPointTime.selected = !controlPointTime.selected;
      this.controlTimes?.forEach(ct => ct.selected = controlPointTime.selected);
      this.disableAll = controlPointTime.selected;
    }
    else if (!this.disableAll){
      controlPointTime.selected = !controlPointTime.selected;
    }
    this.saveEnabled = !!(this.controlTimes?.filter(cp => cp.selected)?.length ?? 0)
  }

  protected readonly WaypointType = WaypointType;
}
